/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import { fetchActionsList } from "../fetchData";
import { MultiSelect } from "primereact/multiselect";

const RiskAssessmentAndControls = ({
  toast,
  formValues,
  setFormValues,
  isUploadInProgress,
  setIsUploadInProgress,
  setIsInitialLoad,
}: any) => {
  const [actionsList, setActionsList] = useState<any>([]);
  const [actionsListLoading, setActionsListLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchActionsList(setActionsList, setActionsListLoading, toast);
    setIsInitialLoad(false);
  }, []);

  // Function to get actions for a particular risk element
  const getActionsForRiskElement = (actionMaster: string) => {
    const actionMasterData = actionsList.find(
      (item: any) => item.actionMaster === actionMaster
    );
    return actionMasterData ? actionMasterData.actions : [];
  };

  return (
    <div>
      <div className="tw-w-full tw-my-4">
        <DataTable
          value={formValues?.startWorkAssessment?.checklist}
          className="tw-w-full custome-leak-detection"
          showGridlines
        >
          <Column
            field="label"
            header="Start Work Assessment"
            className="lg:max-w-[400px] max-w-[300px]"
          ></Column>

          <Column
            header="Yes"
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`pass${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  true
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      checklist: prev.startWorkAssessment.checklist.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: true };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />
          <Column
            header="No"
            style={{ width: "100px" }}
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`fail${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  false
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      checklist: prev.startWorkAssessment.checklist.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: false };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />
        </DataTable>
      </div>

      <div className="tw-text-[#5B5B5B] tw-text-sm tw-mt-4">
        {/* <span className="tw-text-[#F00]">Notes:  </span> */}
        <span className="tw-text-[#F00]">
          If you have answered "no" to any of the above questions, STOP works
          immediately. You must not continue until you have been instructed to
          continue by the Project Manager.
        </span>
      </div>

      <div className="tw-w-full tw-my-4">
        <DataTable
          value={formValues?.startWorkAssessment?.riskelements}
          className="tw-w-full custome-leak-detection"
          showGridlines
        >
          <Column
            field="label"
            header="Risk Elements"
            className="lg:max-w-[400px] max-w-[300px]"
          ></Column>

          <Column
            header="Yes"
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`pass${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.riskelements[rowIndex]
                    .value === true
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      riskelements: prev.startWorkAssessment.riskelements.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: true };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />
          <Column
            header="No"
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`fail${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.riskelements[rowIndex]
                    .value === false
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      riskelements: prev.startWorkAssessment.riskelements.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: false, action: null };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />

          {/* Action Dropdown Column */}
          <Column
            header="Action"
            style={{ width: "200px" }}
            body={(rowData, { rowIndex }) => {
              const riskElement =
                formValues?.startWorkAssessment?.riskelements[rowIndex];
              const actionsForRiskElement = getActionsForRiskElement(
                riskElement.name
              );

              return (
                <MultiSelect
                  id="teamMember1"
                  selectAllLabel="Select All"
                  maxSelectedLabels={1}
                  optionLabel="name"
                  placeholder="Action Taken"
                  value={riskElement.action}
                  disabled={
                    riskElement.value === false ||
                    riskElement.value === null ||
                    isUploadInProgress
                  }
                  loading={actionsListLoading}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      startWorkAssessment: {
                        ...prev.startWorkAssessment,
                        riskelements: prev.startWorkAssessment.riskelements.map(
                          (item: any, index: number) => {
                            if (index === rowIndex) {
                              return { ...item, action: e.value };
                            }
                            return item;
                          }
                        ),
                      },
                    }));
                  }}
                  options={actionsForRiskElement}
                  className="tw-border tw-border-solid tw-rounded-full tw-px-2 placeholder:tw-font-normal filter-dropdown"
                />
              );
            }}
          />
        </DataTable>
      </div>

      <div className="tw-text-[#5B5B5B] tw-text-sm tw-mt-4">
        {/* <span className="tw-text-[#F00]">Notes:  </span> */}
        <span className="tw-text-[#F00]">
          The assessment must be discussed and agreed with all other team
          members who must sign below to confirm they understand and that the
          works area, plant and equipment are safe, and works can proceed
          safely.
        </span>
      </div>

      <div className="tw-mt-4">
        <span className="tw-text-[#5B5B5B] tw-text-sm tw-font-semibold">
          Additional comments if any:-
        </span>
        <InputTextarea
          value={formValues?.additionalComments ?? ""}
          onChange={(e) => {
            setFormValues((prev: any) => ({
              ...prev,
              additionalComments: e.target.value,
            }));
          }}
          disabled={isUploadInProgress}
          className="tw-w-full tw-mt-2"
        />
      </div>
    </div>
  );
};

export default RiskAssessmentAndControls;
